module.exports = __webpack_public_path__ + "static/media/spike-waveforms.50fe82a5.jpg";